import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/cookie" element={<CookiePolicy />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
